<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("CONTACTS.ADD_CONTACT") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <contact-form
              :loading="loading"
              :contactData="contact"
              :formErrors="formErrors"
              @contactSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultContact from "./defaultContact";
import ContactForm from "./partials/ContactForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ContactForm,
  },

  mixins: [alertLeave],

  data() {
    const contact = cloneDeep(defaultContact);
    return {
      contact: contact,
      formErrors: null,
      loading: false,
    };
  },

  methods: {
    goBack() {
      this.$router.push({ name: "List Contacts" });
    },

    viewContact(contact) {
      this.alertLeave = false;
      this.$router.push({
        name: "View Contact",
        params: { id: contact.id },
      });
    },

    async handleSubmit(contact) {
      this.loading = true;
      const contactData = cloneDeep(contact);

      try {
        await this.$store.dispatch("contacts/add", contactData);
        this.$notify({
          type: "success",
          message: this.$t("CONTACTS.CONTACT_ADDED"),
        });
        const contact = await this.$store.getters["contacts/contact"];
        this.viewContact(contact);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        const contact = await this.$store.getters["contacts/contact"];
        if (contact.id) {
          await this.$store.dispatch("contacts/destroy", contact.id);
        }
        this.loading = false;
      }
    },
  },
};
</script>
